import { render, staticRenderFns } from "./Achievements.vue?vue&type=template&id=386290ec&scoped=true"
import script from "./Achievements.vue?vue&type=script&lang=js"
export * from "./Achievements.vue?vue&type=script&lang=js"
import style0 from "./Achievements.vue?vue&type=style&index=0&id=386290ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386290ec",
  null
  
)

export default component.exports